var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFofoPeek(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 125,
    viewBox: "0 0 206 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_219_42246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.47 72.048L169.938 90.0294C168.905 97.3669 170.088 104.846 173.336 111.506L178.541 122.179C191.428 148.602 179.722 180.44 152.788 192.222L119.775 206.663C81.654 223.339 34.2551 215.404 16.2456 177.895C-12.9761 117.034 6.61783 66.5513 32.6322 33.6819C53.5831 7.21024 90.7084 5.98013 121.514 19.7891L150.868 32.9473C165.972 39.7174 174.778 55.6585 172.47 72.048Z",
    fill: "#A56644"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.005 4.99223C168.379 0.335902 161.666 -0.499744 157.009 3.12576L151.644 7.30321C146.988 10.9287 146.152 17.6425 149.778 22.2988C153.403 26.9551 160.117 27.7908 164.773 24.1653L170.139 19.9878C174.795 16.3623 175.63 9.64856 172.005 4.99223Z",
    fill: "#A56644"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.857 45.2403C206.544 50.8953 203.327 56.8473 197.672 58.5345L191.157 60.4786C185.502 62.1658 179.55 58.9492 177.862 53.2942C176.175 47.6392 179.392 41.6872 185.047 40L191.563 38.0559C197.218 36.3687 203.17 39.5853 204.857 45.2403Z",
    fill: "#A56644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7385 113.87L79.1302 138.724L171.282 80.484L170.046 89.2625C168.945 97.0759 170.36 105.037 174.085 111.993L176.309 116.146L83.9823 155.951L83.662 156.122L83.0229 156.039L4.96833 146.103C2.39896 134.886 1.43065 124.123 1.7385 113.87Z",
    fill: "#2FE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.993 40.019C119.796 44.6027 123.216 55.4548 118.633 64.2579L115.941 69.4275C111.357 78.2306 100.505 81.6511 91.7021 77.0674C82.899 72.4837 79.4785 61.6316 84.0622 52.8285L86.7539 47.6589C91.3376 38.8558 102.19 35.4353 110.993 40.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1294 30.5629C60.6016 25.4853 49.5723 28.2823 44.4947 36.8101L41.513 41.8179C36.4354 50.3457 39.2323 61.375 47.7601 66.4526C56.2879 71.5302 67.3172 68.7333 72.3948 60.2055L75.3766 55.1976C80.4542 46.6698 77.6572 35.6405 69.1294 30.5629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.269 48.5362C112.664 44.2385 109.501 40.4341 105.203 40.0389C95.029 39.1032 86.0229 46.5923 85.0872 56.7662C84.6919 61.0639 87.8555 64.8683 92.1532 65.2635C95.7598 65.5952 99.019 63.4206 100.208 60.1727C100.654 58.9524 101.212 57.7308 102.211 56.8999C103.21 56.069 104.513 55.7434 105.794 55.5269C109.205 54.9507 111.937 52.1428 112.269 48.5362Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5834 41.3952C71.8654 37.2772 69.5663 32.8996 65.4483 31.6176C55.6998 28.5828 45.3369 34.0252 42.302 43.7738C41.02 47.8917 43.319 52.2693 47.437 53.5513C50.8928 54.6271 54.5314 53.181 56.3699 50.2544C57.0607 49.1547 57.8605 48.077 59.0102 47.4732C60.1599 46.8694 61.5011 46.8227 62.7986 46.8782C66.2516 47.0258 69.5075 44.851 70.5834 41.3952Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0566 78.0675C102.405 66.6779 121.649 67.4556 133.039 79.8045L137.094 84.2015L110.338 108.88L85.6596 82.1229L90.0566 78.0675Z",
    fill: "#A56644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.866 76.7863C58.4365 60.5814 41.7091 51.0356 25.5042 55.4651L22.6595 56.2427L31.4574 88.4289L63.6436 79.631L62.866 76.7863Z",
    fill: "#A56644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9185 74.4449C69.2223 83.8849 69.3178 96.5771 72.4072 104.798",
    stroke: "#E5A259",
    strokeWidth: 39.5432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0965 86.2485C66.6139 85.167 67.9101 84.7096 68.9916 85.227C72.0708 86.7 74.646 86.9818 76.8383 86.388C79.0393 85.7919 81.1905 84.2224 83.2361 81.3383C83.9298 80.3603 85.2848 80.1299 86.2628 80.8235C87.2407 81.5171 87.4712 82.8722 86.7775 83.8501C84.3391 87.2879 81.423 89.6445 77.9733 90.5788C74.515 91.5154 70.8561 90.9318 67.118 89.1437C66.0365 88.6263 65.5791 87.3301 66.0965 86.2485Z",
    fill: "#D08738"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.79973,
    transform: "matrix(-0.979097 0.203392 0.203392 0.979097 72.7001 60.4854)",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.2809,
    cy: 42.0662,
    r: 5.59569,
    transform: "rotate(29.3826 65.2809 42.0662)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.147,
    cy: 50.9325,
    r: 5.59569,
    transform: "rotate(26.1179 107.147 50.9325)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_219_42246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 125,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFofoPeek);
export default __webpack_public_path__ + "static/media/fofo-peek.3165c20f1ae150158bc70c94be45e325.svg";
export { ForwardRef as ReactComponent };